module.exports = __webpack_public_path__ + "img/inbox.06b4a81c.svg";